<hyperkit-dialog class="hyperkit-component" headerText="New Environment">
  <div class="container-fluid">
    <div class="row">
      <div class="container">
        @if (error) {
          <hyperkit-error [error]="error"></hyperkit-error>
        }
        <form
          class="k-form"
          [formGroup]="formGroup"
          autocomplete="off"
          (ngSubmit)="onSubmit()"
        >
          <kendo-formfield>
            <label for="name">Environment Name*</label>
            <input
              id="name"
              formControlName="name"
              maxlength="50"
              kendoTextBox
            />
            <kendo-formerror>Error: Name is required</kendo-formerror>
          </kendo-formfield>
          <kendo-formfield>
            <kendo-label
              [for]="description"
              text="Description"
              class="customizing-label"
            ></kendo-label>
            <kendo-textarea
              #description
              name="description"
              formControlName="description"
              resizable="vertical"
              [maxlength]="200"
            >
            </kendo-textarea>
          </kendo-formfield>
          <hyperkit-button
            size="small"
            color="tertiary"
            text="Save"
            type="submit"
            [disabled]="!formGroup.valid"
          ></hyperkit-button>
        </form>
      </div>
    </div>
  </div>
</hyperkit-dialog>
